import { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./common/ProtectedRoute"; 
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";

import UserAccounts from "./scenes/useraccounts";
import Subscriptions from "./scenes/subscriptions";

import Landing from "./pages/landing";
import Login from "./pages/login";
import Logout from "./pages/logout";
import Reset from "./pages/reset";
import Signup from "./pages/signup";
import ContactUs from "./pages/contactus";
import Subscribe from "./pages/subscribe";
import Pricing from "./pages/pricing";
import CheckoutSuccess from "./pages/subscribe/steps/checkoutsuccess";
import CheckoutCancelled from "./pages/subscribe/steps/checkoutcancel";
import CheckoutSuccessDodo from "./pages/subscribe/steps/checkoutsuccessdodo";
import CheckoutCancelledDodo from "./pages/subscribe/steps/checkoutcanceldodo";

import ConfirmMarketingOptIn from "./pages/confirmmarketingoptin";

import PaidMarketingLandingPage from "./pages/paidmarketinglandingpage";

import PaidMarketingLandingPageReddit from "./pages/paidmarketinglandingpagereddit";

import  OptOutOfMarketingEmails from "./pages/optoutmarketingemails";

import  OptOutOfPPCMarketingEmails from "./pages/optoutppcmarketingemails";

import  DemoPage from "./pages/demopage";

import TermsOfService from "./pages/termsofservice";

import Dashboard from "./scenes/dashboard";

import Unauthorized from "./scenes/unauthorized";

import NotFound from "./pages/pagenotfound";

import Clients from "./scenes/clients";
import Suppliers from "./scenes/suppliers";
import Services from "./scenes/services";
import Properties from "./scenes/properties";
import Staff from "./scenes/staff";
import Accounts from "./scenes/accounts";
import Invoices from "./scenes/invoices";
import InvoicesByStatus from "./scenes/invoices/indexByStatus";
import InvoicesByCurrency from "./scenes/invoices/indexByCurrency";
import BookkeepingManagement from "./scenes/bookkeepingmanagement";
import BookkeepingManagementByType from "./scenes/bookkeepingmanagement/indexByType";
import Inventory from "./scenes/inventory";
import SupplyOrders from "./scenes/supplyorders";
import Schedules from "./scenes/schedules";
import Payrolls from "./scenes/payrolls";
import PayrollsByPaymentStatus from "./scenes/payrolls/indexByPaymentStatus";
import Teams from "./scenes/teams";


import ToastMessageDisplay from "./common/ToastMessageDisplay"; 
import { UserProvider } from "./common/UserContext";
import { ApplicationModeProvider } from "./common/ApplicationModeContext";
import { UserCountProvider } from "./common/UserCountContext";
import { AccountProvider } from "./common/AccountContext";

import Bar from "./scenes/bar";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import { Navigate } from "react-router-dom";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");  // Add this line to hold the search term
  const location = useLocation();

  const publicPaths = ["/", 
    "/index.html", 
    "/login", 
    "/logout", 
    "/reset", 
    "/signup",
    "/contactus", 
    "/subscribe", 
    "/pricing", 
    "/terms-of-service", 
    "/confirm-marketing-opt-in",
    "/opt-out-of-marketing-emails",
    "/opt-out-of-ppc-marketing-emails",
    "/checkout-success", 
    "/checkout-cancelled",
    "/checkout-dodo-success", 
    "/checkout-dodo-cancelled",

    "/not-found",
    "/limited-time-discount-offer",
    "/demo",
    "/i-built-a-tool"];

  const isPublic = publicPaths.includes(location.pathname);

/************************************ PUBLIC PAGES ********************************************* */

if (isPublic) {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/index.html" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/confirm-marketing-opt-in" element={<ConfirmMarketingOptIn />} />
      <Route path="/opt-out-of-marketing-emails" element={<OptOutOfMarketingEmails />} />
      <Route path="/opt-out-of-ppc-marketing-emails" element={<OptOutOfPPCMarketingEmails />} />
      <Route path="/limited-time-discount-offer" element={<PaidMarketingLandingPage />} />
      <Route path="/i-built-a-tool" element={<PaidMarketingLandingPageReddit />} />
      <Route path="/demo" element={<DemoPage />} />

      <Route path="/checkout-success" element={<CheckoutSuccess />} />
      <Route path="/checkout-cancelled" element={<CheckoutCancelled />} />
      <Route path="/checkout-dodo-success" element={<CheckoutSuccessDodo />} />
      <Route path="/checkout-dodo-cancelled" element={<CheckoutCancelledDodo />} />

      <Route path="/not-found" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/************************************ PRIVATE PAGES ********************************************* */

  return (
    <ApplicationModeProvider>  
      <UserProvider>
        <UserCountProvider>
          <AccountProvider>
            <ColorModeContext.Provider value={colorMode}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <div className="app">
                  <Sidebar isSidebar={isSidebar} />
                  <main className="content">
                    <Topbar setIsSidebar={setIsSidebar} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
                    <Routes>
                      <Route path="/app" element={<ProtectedRoute element={<Dashboard />} />} />

                      <Route path="/clients" element={<ProtectedRoute element={<Clients searchTerm={searchTerm} />} />} />
<Route path="/suppliers" element={<ProtectedRoute element={<Suppliers searchTerm={searchTerm} />} />} />
<Route path="/services" element={<ProtectedRoute element={<Services searchTerm={searchTerm} />} />} />
<Route path="/properties" element={<ProtectedRoute element={<Properties searchTerm={searchTerm} />} />} />
<Route path="/staff" element={<ProtectedRoute element={<Staff searchTerm={searchTerm} />} />} />
<Route path="/accounts" element={<ProtectedRoute element={<Accounts searchTerm={searchTerm} />} />} />
<Route path="/invoices" element={<ProtectedRoute element={<Invoices searchTerm={searchTerm} />} />} />
<Route path="/invoices/list" element={<ProtectedRoute element={<Invoices searchTerm={searchTerm} />} />} />
<Route path="/invoices/status" element={<ProtectedRoute element={<InvoicesByStatus searchTerm={searchTerm} />} />} />
<Route path="/invoices/currency" element={<ProtectedRoute element={<InvoicesByCurrency searchTerm={searchTerm} />} />} />
<Route path="/bookkeepingmanagement" element={<ProtectedRoute element={<BookkeepingManagement searchTerm={searchTerm} />} />} />
<Route path="/bookkeepingmanagement/list" element={<ProtectedRoute element={<BookkeepingManagement searchTerm={searchTerm} />} />} />
<Route path="/bookkeepingmanagement/type" element={<ProtectedRoute element={<BookkeepingManagementByType searchTerm={searchTerm} />} />} />
<Route path="/inventory" element={<ProtectedRoute element={<Inventory searchTerm={searchTerm} />} />} />
<Route path="/inventory/list" element={<ProtectedRoute element={<Inventory searchTerm={searchTerm} />} />} />
<Route path="/supplyorders" element={<ProtectedRoute element={<SupplyOrders searchTerm={searchTerm} />} />} />
<Route path="/supplyorders/list" element={<ProtectedRoute element={<SupplyOrders searchTerm={searchTerm} />} />} />
<Route path="/schedules" element={<ProtectedRoute element={<Schedules searchTerm={searchTerm} />} />} />
<Route path="/schedules/list" element={<ProtectedRoute element={<Schedules searchTerm={searchTerm} />} />} />
<Route path="/payrolls" element={<ProtectedRoute element={<Payrolls searchTerm={searchTerm} />} />} />
<Route path="/payrolls/list" element={<ProtectedRoute element={<Payrolls searchTerm={searchTerm} />} />} />
<Route path="/payrolls/paymentstatus" element={<ProtectedRoute element={<PayrollsByPaymentStatus searchTerm={searchTerm} />} />} />
<Route path="/teams" element={<ProtectedRoute element={<Teams searchTerm={searchTerm} />} />} />
<Route path="/teams/list" element={<ProtectedRoute element={<Teams searchTerm={searchTerm} />} />} />


                      <Route path="/pie" element={<ProtectedRoute element={<Pie />} />} />
                      <Route path="/line" element={<ProtectedRoute element={<Line />} />} />
                      <Route path="/calendar" element={<ProtectedRoute element={<Calendar />} />} />
                      <Route path="/geography" element={<ProtectedRoute element={<Geography />} />} />

                      <Route path="/useraccounts" element={<ProtectedRoute element={<UserAccounts />} role="admin" />} />
                      <Route path="/subscriptions" element={<ProtectedRoute element={<Subscriptions />} role="admin" />} />

                      <Route path="/unauthorized" element={<ProtectedRoute element={<Unauthorized />} />} />

                      <Route path="*" element={<Navigate to="/not-found" replace />} />

                    </Routes>
                    <ToastMessageDisplay />
                  </main>
                </div>
              </ThemeProvider>
            </ColorModeContext.Provider>
            </AccountProvider>
        </UserCountProvider>
      </UserProvider>
    </ApplicationModeProvider>
  );
}

export default App;
